import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface DiscontinuedProductStyles {
    DiscontinuedGridItem?: GridItemProps;
    contactUs?: InjectableCss;
    discontinuedMsg?: InjectableCss;
    container?: InjectableCss;
}

export const discontinuedProductStyles: DiscontinuedProductStyles = {
    DiscontinuedGridItem: {
        width: 12,
        css: css`
            display: block;
            color: rgb(162, 16, 16);
            padding: 0;
            font-size: 18px;
            font-weight: 600;
        `,
    },
    contactUs: {
        css: css`
            > span[class^="TypographyStyle"] {
                text-decoration: underline;
            }
        `,
    },
    container: {
        css: css`
            margin-top: 50px;
        `,
    },
};

const styles = discontinuedProductStyles;

const DiscontinuedProduct: React.FC<Props> = ({ product }) => {
    const [discontinued, setDiscontinued] = React.useState(false);
    React.useEffect(() => {
        if (product.properties.productDiscontinued === "true") {
            setDiscontinued(true);
        }
    }, []);

    return (
        <StyledWrapper {...styles.container}>
            {discontinued && (
                <GridItem {...styles.DiscontinuedGridItem} data-test-selector="discontinued_product">
                    <Typography {...styles.discontinuedMsg}>
                        {translate(" This item is now discontinued. Please")}
                    </Typography>
                    &nbsp;
                    <Link {...styles.contactUs} href="/ContactUs">
                        {translate("Contact us")}
                    </Link>{" "}
                    &nbsp;
                    <Typography {...styles.discontinuedMsg}>
                        {translate("for more information about replacement items.")}
                    </Typography>
                </GridItem>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(DiscontinuedProduct),
    definition: {
        displayName: "Discontinued Product",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
